import React from "react";

import { cn } from "../../lib/utils";

import { LoadingState } from "./shared/LoadingState";
import { StepHeader } from "./shared/StepHeader";
import { STEP_BODY_CLASS } from "./shared/StepLayout";

import type { Integration } from "../types/integrations";

interface LoadingStepProps {
  integration: Integration;
}

export function LoadingStep({ integration }: LoadingStepProps) {
  return (
    <div className={cn(STEP_BODY_CLASS, "flex flex-col")}>
      <div className="my-auto flex flex-col items-center py-12">
        <StepHeader
          integration={integration}
          title={integration.value}
          className="flex items-center gap-4 mb-8"
        />

        <LoadingState
          message="Checking connection status..."
          className="flex flex-col items-center gap-4"
          iconSize="lg"
        />
      </div>
    </div>
  );
}
